import BgStandard from './BgStandard';

const EXPORT = {
  BgStandard,
};

export default EXPORT;
